module.exports = __webpack_public_path__ + "img/treasure-stroke.63cb70d9.png";